const indexURL = 'https://raw.githubusercontent.com/w3c/webref/master/ed/index.json';
const specURL = 'https://raw.githubusercontent.com/w3c/webref/master/ed/dfns/';

export {
  indexURL,
  specURL
}
